import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TopNavbar from "./components/TopNavbar";

// Lazy load route components
const Home = lazy(() => import("./pages/Home"));
const Collection = lazy(() => import("./pages/Collection"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Cart = lazy(() => import("./pages/Cart"));
const Checkout = lazy(() => import("./pages/Checkout"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Couples = lazy(() => import("./pages/Couples"));
const NotFound = lazy(() => import("./pages/NotFound"));

const LoadingFallback = () => (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    fontSize: "18px",
    color: "#666"
  }}>
    Chargement...
  </div>
);

export default function App() {
  return (
    <div className="app-shell">
      <TopNavbar />
      <Navbar />

      <main>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/collection" element={<Collection />} />

            <Route path="/produit/:id" element={<ProductDetails />} />

            <Route path="/a-propos" element={<About />} />

            <Route path="/contact" element={<Contact />} />

            <Route path="/faq" element={<FAQ />} />

            <Route path="/panier" element={<Cart />} />

            <Route path="/checkout" element={<Checkout />} />

            <Route path="/couples" element={<Couples />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
    </div>
  );
}
